"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { CalendarHeart } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ConsultationCTA() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="consultationcta" className="relative py-24 md:py-32 px-6 overflow-hidden flex items-center justify-center bg-primary text-primary">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-accent/40 via-background to-chart-2/20 pointer-events-none" />

      {}
      <div className="absolute -top-24 -left-24 w-96 h-96 bg-accent/30 rounded-full mix-blend-multiply filter blur-3xl opacity-60 pointer-events-none" />
      <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-chart-2/20 rounded-full mix-blend-multiply filter blur-3xl opacity-60 pointer-events-none" />

      <div ref={ref} className={`relative z-10 max-w-3xl mx-auto text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-4xl font-medium mb-6 leading-tight !font-serif md:text-5xl lg:text-6xl text-primary">
          Begin Your Journey to a Joyful Birth
        </h2>
        
        <p className="font-sans text-lg md:text-xl text-foreground/80 mb-10 max-w-2xl mx-auto leading-relaxed">
          Whether you are planning a hospital birth, a home birth, or seeking compassionate postpartum care in West Palm Beach, I am here to support you. Let's connect and discuss how we can make your experience truly empowering.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="w-full sm:w-auto rounded-full px-8 py-7 text-lg shadow-lg shadow-primary/10 hover:shadow-xl hover:shadow-primary/20 transition-all duration-300 hover:-translate-y-1 bg-primary text-primary-foreground">
            <Link to="/LetsConnectPage">
              <CalendarHeart className="mr-2 h-5 w-5" />
              Book Your Free Consultation
            </Link>
          </Button>
        </div>
        
        <p className="mt-6 text-sm text-foreground/60 font-sans">
          No obligation. Just a warm conversation about your growing family.
        </p>
      </div>
    </section>;
}